interface GetReviewEntryDetailTitleOptions {
  invoiceNumber?: string
  typeLabel: string
}

export const getReviewEntryDetailTitle = ({ invoiceNumber, typeLabel }: GetReviewEntryDetailTitleOptions): string => {
  const number = invoiceNumber?.trim()

  if (!number) {
    return typeLabel
  }

  return `${typeLabel} ${number}`
}
